$(function () {
	/* Header */
		$('#nav-icon4').click(function(){
			$(this).toggleClass('open');
		});

		$('#nav-icon4').on('click', function() {
            if($('' + $(this).data('target')).hasClass('active')) {
                $('' + $(this).data('target')).removeClass('active');
            }else {
                $('' + $(this).data('target')).addClass('active');
            }
        });

		// change navbar to fixed when scroll
		$(document).scroll(function () {
		    var $nav = $(".navbar");
		    $nav.toggleClass('scrolled', $(this).scrollTop() > ($nav.height() / 3 ) );
		});

	/* Footer */
		Array.prototype.forEach.call(document.querySelectorAll('.partner-logo'), function(element) {
		  element.addEventListener('touchstart', function(e) {
		    	e.target.classList.add('hover');
		  }, { passive: true });
		  element.addEventListener('mouseenter', function(e) {
		    	e.target.classList.add('hover');
		  }, { passive: true });
		});

		Array.prototype.forEach.call(document.querySelectorAll('.partner-logo'), function(element) {
		  element.addEventListener('touchend', function(e) {
		    	e.target.classList.remove('hover');
		  }, { passive: true });
		  element.addEventListener('mouseleave', function(e) {
		    	e.target.classList.remove('hover');
		  }, { passive: true });
		});

		$('body').on('click', '.subcribe-btn, #subscribe-button', function(e) {
			$('.subcribe-btn').addClass('hide');
			$('.subcribe-form-section').addClass('active');	
		});

		$('body').on('click', '.close-subcribe-form-button', function(e) {
			$('.subcribe-btn').removeClass('hide');
			$('.subcribe-form-section').removeClass('active');
		});

		$('body').on('submit', '#subcribe_form', function(e) {
			event.preventDefault();
		    $('#subcribe_form .btn-subscribe').addClass('disabled').prop('disabled', true);
		    $.post($(this).attr('action'), {
		        subcribe_email: $('#subcribe_email').val(),
		        _token: $('input[name=_token]').val(),
			}).done(function(data) {
				// gtag('event', 'conversion', {'send_to': 'AW-10948760273/KOPeCJizrcIYENGl4-Qo'}); // Send conversion for GA

		        $('#thankyouSubscribeModal').modal('show');
		        $('#subcribe_form .btn-subscribe').removeClass('disabled').prop('disabled', false);
		        $('#subcribe_form')[0].reset();
		        $('.subcribe-btn').removeClass('hide');
				$('.subcribe-form-section').removeClass('active');

		    }).fail(function(jqXHR, textStatus, errorThrown) {
		    	$('#subcribe_form .btn-subscribe').removeClass('disabled').prop('disabled', false);
		        if(jqXHR.responseJSON.b_success == 0){
		            $('#errorModal').modal('show');
		            $('#subcribe_form')[0].reset();
		            $('.subcribe-btn').removeClass('hide');
					$('.subcribe-form-section').removeClass('active');
		        }
		        $.each(jqXHR.responseJSON,function(tKey,objError){
		            $('#'+tKey+'Error').removeClass('d-none');
		            $('#'+tKey+'Error').text(objError[0]);
		        });
		    });
		});

		$('body').on('keyup keypress blur change', '#subcribe_form input' ,function(e){
		    var tId = $(this).attr('id');
		    $('#'+tId+'Error').addClass('d-none');
		    $('#'+tId+'Error').html('');
		});

});